import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'autocomplete',
	templateUrl: './autocomplete.component.html',
	styleUrls: ['./autocomplete.component.css']
})
export class AutocompleteComponent implements OnInit {
	@Input() arr;
	@Input() display;
	@Input() value;
	@Output() choose = new EventEmitter();
	constructor() { }

	ngOnInit() {
	}

	onChoose(data) {
		this.choose.emit(data);
		this.arr = null;
	}

}



// WEBPACK FOOTER //
// D:/wamp/www/sportal/pmi/web/src/app/shared/autocomplete/autocomplete.component.ts